<template>
  <div class="coupon-with-checbox" @click="handleClick">
    <x-checkbox
      v-model="couponInfo.checked"
      :disabled="couponInfo.disabled"
      :uid="couponInfo.muuid"
      @onChange="handleChange"
    ></x-checkbox>
    <coupon-item
      :incoupon="couponInfo"
      :hideRight="true"
      style="flex: 1; margin-left: 0.16rem"
    ></coupon-item>
  </div>
</template>
<script>
import couponItem from '../large/item'
import xCheckbox from '@/components/checkbox'
import { COUPON_RECEIVED_STATUS } from '@/config'
import { isNonEmptyArray } from '@/utils'
export default {
  props: {
    couponInfo: Object
  },
  components: {
    couponItem,
    xCheckbox
  },
  created() {
    // 默认勾选的一张券，如果未领取，主动领取
    if (this.couponInfo.checked) {
      this.getCoupon()
    }
  },
  methods: {
    handleChange({ uid, checked }) {
      // console.log(uid, checked)
      if (this.handleClick()) return
      checked && this.getCoupon()
      this.$emit('onSelect', { couponInfo: checked ? this.couponInfo : null })
    },
    handleClick() {
      const { disabled, reason } = this.couponInfo
      if (disabled) {
        this.$$toast(reason)
      }
      return disabled
    },
    async getCoupon() {
      // 未领取 主动领券
      const {
        userGetStatus,
        couponCode,
        userGetLimit,
        userGetCount,
        disabled
      } = this.couponInfo
      if (userGetStatus === COUPON_RECEIVED_STATUS.DONE || disabled) return
      // console.log('getCoupon')
      if (userGetLimit > 0 && userGetLimit === userGetCount) {
        this.couponInfo.disabled = true
        this.couponInfo.checked = false
        this.$$toast('没领到哦，您的单张券已领取达到上限')
        return
      }
      if (this.fetchStatus) {
        return
      }
      this.fetchStatus = true
      const uid = this.$$cookie('uid')
      const skey = this.$$cookie('skey')
      const json = await this.$store.dispatch('userGetCoupon', {
        couponCode,
        uid,
        skey
      })
      let { code, data } = json
      code = +code
      if (code === 1) {
        this.couponInfo.userGetCount = userGetCount + 1
        this.couponInfo.userGetStatus = COUPON_RECEIVED_STATUS.DONE
        if (isNonEmptyArray(data)) {
          this.couponInfo.couponPassword = data[0]
        }
        // this.$$toast('领取成功')
      } else if (code === 4) {
        this.$$login()
      } else {
        if (code === 2004) {
          this.couponInfo.leftCount = 0
          this.couponInfo.disabled = true
        }
        // console.log(json)
        this.$$toast(json.msg)
      }
      this.fetchStatus = false
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-with-checbox {
  width: 100%;
  display: flex;
  align-items: center;
}
</style>
